"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonTermsAndConditions = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("./styles");
var common_terms_and_conditions_docx_1 = __importDefault(require("../../static/docs/common-terms-and-conditions.docx"));
var Layout_1 = __importDefault(require("../Layout"));
function CommonTermsAndConditions() {
    return (
    // <IFrame src={termAndCondition} frameBorder="0">
    // </IFrame>
    (0, jsx_runtime_1.jsx)(Layout_1.default, { children: (0, jsx_runtime_1.jsx)(styles_1.Content, { dangerouslySetInnerHTML: { __html: common_terms_and_conditions_docx_1.default } }) }));
}
exports.CommonTermsAndConditions = CommonTermsAndConditions;
